import { Component, inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import FieldsConstants from 'src/app/common/fields.constants';
import { MessageLevel } from 'src/app/interfaces';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationState } from 'src/app/notifications/notifications.state';
import { FieldCustomValidators } from '../../../forms/fields/field-custom.validators';
import { DIALOG_DEFAULT_DATA } from '../dialog-default/dialog-default.component';

@Component({
  selector: 'app-dialog-conversation-title-edit',
  templateUrl: './dialog-conversation-title-edit.component.html',
  styleUrls: ['./dialog-conversation-title-edit.component.scss'],
})
export class DialogConversationTitleEditComponent extends NotificationState implements OnInit {
  public readonly modalArguments = inject(DIALOG_DEFAULT_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  protected notificationLevel: MessageLevel = 'INFO';

  public submitButton: string = DialogActionTypes.SUBMIT;

  public conversationTitle: FormControl<string> = new FormControl('', {
    nonNullable: true,
    validators: [
      Validators.required,
      Validators.maxLength(FieldsConstants.CHAT_MAX_TITLE_LENGTH),
      FieldCustomValidators.nonEmptyValidator(),
    ],
  });

  public ngOnInit(): void {
    this.initForm();
  }

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public get isValid(): boolean {
    return this.conversationTitle.valid;
  }

  public submit(): void {
    if (this.isValid) {
      this.activeModal.close(this.conversationTitle.value);
    }
  }

  public clearInput(inputField: HTMLInputElement): void {
    this.conversationTitle.setValue('');
    this.conversationTitle.markAsTouched();
    inputField.focus();
  }

  public get maxLength(): number {
    return FieldsConstants.CHAT_MAX_TITLE_LENGTH;
  }

  private initForm(): void {
    this.conversationTitle.patchValue(this.modalArguments.description);
  }
}
